module.exports = __webpack_public_path__ + "img/dudu_icon.40221557.png";